import { defineMessages } from "react-intl";

const PREFIX = "Favourites.FavouritesToolbar";
export const messages = defineMessages({
  titlePage: {
    id: `${PREFIX}.titlePage`,
    defaultMessage: "Favourites",
  },
});
